/**
 * Import Dependency
 */
import data from '@/data.json';
import selectOne from '@/helpers/selectOne';

/**
 * Import API
 */

/**
 * Declare Variable
 */
const state = {
  gemeenten : data.gemeenten
}
const getters = {
  getGemeentenList: state => {
    return state.gemeenten;
  },
  getGemeenteById: state => ({ id }) => {
    return selectOne({
      from: state.gemeenten, 
      property: 'id', 
      value: id
    });
  },
  getGemeenteBySlug: state => ({ slug }) => {
    return selectOne({
      from: state.gemeenten, 
      property: 'slug', 
      value: slug
    });
  },
}
const actions = {}
const mutations = {}

/**
 * Export
 */
export default {
  state,
  getters,
  actions,
  mutations
}
